<template>
  <div id="registrationEmailLink" class="modal fade email-popup" role="dialog">
    <div class="modal-dialog modal-lg email-share-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header" style="font-weight: 600;">
          <template v-if="meta.mode === '3'">
            <div style="display: flex;">
              <div style=" padding-right: 8px;">
                <img src="/static/images/icons/emergo_logo.svg" />
              </div>
              <div>
                <div>Contact Emergo for renewal support</div>
                <div style="font-size: 12px;color: #69b2e9 !important;">
                  <i class="fa fa-external-link"></i>
                  <a href="https://www.emergobyul.com/" target="_blank">Learn more about Emergo</a>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <span v-if="meta.isLink">
              <img src="/static/images/icons/icon_link_black.svg" /> Email registration link
            </span>
            <span v-else>
              <img src="/static/images/icons/icon_email_black.svg" /> Email registration share
            </span>
          </template>
        </div>
        <div class="modal-body" style="padding: 0px;padding-bottom: 10px;padding-top: 20px;">
          <div class="col-md-12" style="padding: 10px;">
            <div class="col-md-2">
              To:
              <span style="color: red;">*</span>
            </div>
            <div class="col-md-10" style="padding: 0;" v-if="meta.mode !== '3'">
              <v-select
                :options="ramsUserList"
                multiple
                allowToAddItem
                :searchable="true"
                v-model="selectedUsers"
                style="width: 100%"
                :close-on-select="true"
                label="userName"
                :autocomplete="true"
                :placeholder="placeValue"
              ></v-select>
            </div>
            <div class="col-md-10" style="padding: 0;" v-else>
              <input type="text" v-model="emergoEmail" class="form-control" disabled />
            </div>
          </div>

          <div class="col-md-12" style="padding: 10px;">
            <div class="col-md-2">Subject:</div>
            <div class="col-md-10" style="padding: 0;">
              <input type="text" class="form-control" v-model="emailSubject" />
            </div>
          </div>

          <div class="col-md-12" style="padding: 10px;">
            <div class="col-md-2">Note:</div>
            <div class="col-md-10" style="padding: 0;">
              <textarea class="form-control" v-model="emailNote"></textarea>
            </div>
          </div>

          <div class="col-md-12" style="padding: 10px;" v-if="meta.isLink">
            <div class="col-md-2">Contents:</div>
            <div class="col-md-10" style="padding: 0;">
              <div class="mail-body">
                You can view the registration in Conformity Declaration Management here:
                <br />
                <a target="_blank" :href="registrationLink">{{registrationLink}}</a>
              </div>
            </div>
          </div>

          <div class="col-md-12" style="padding: 10px;" v-else>
            <div class="col-md-2">Contents:</div>
            <div class="col-md-10 mail-body">
              <div v-if="meta.mode === '3'" style="padding-bottom: 10px;">
                Hello,
                <br />
                <br />I am interested in finding out how Emergo can help me with the renewal of the registration below.
                <br />Please contact me via email at
                <span style="color: #69b2e9;">{{loggedInUser.email}}</span>.
              </div>
              <div v-else>
                <p>Here are the registration details from Conformity Declaration Management:</p>
              </div>
              <div class="modal-header">
                <div style="display: flex;">
                  <div style="padding-right: 8px">
                    <span
                      class="flag-icon flag-icon-squared"
                      style="font-size: 50px;"
                      :class="countryFlag(data['Country Code'])"
                    ></span>
                  </div>
                  <div style="overflow: hidden;">
                    <div class="modal-title" style="margin-bottom: 5px;">
                      <span
                        class="registration-status-title"
                        :class="statusColor(data.Status)"
                      >{{data.Status}} Registration</span>
                    </div>
                    <div
                      class="modal-title"
                      style="font-weight: 600;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
                      :title="data.Product"
                    >{{data.Product}}</div>
                    <div>{{data['Country']}}</div>
                  </div>
                </div>
              </div>
              <div class="modal-body">
                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Record number</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['Record number']}}</span>
                    </div>
                  </div>
                </div>
                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Record Type</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['Record type'] || '-'}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 padding-reset">
                  <div class="col-md-5">Device class (in {{data['Country']}})</div>
                  <div class="col-md-7">
                    <span class="text-bold">
                      <div v-if="data['Device class']" class="pointer">{{data['Device class']}}</div>
                      <div v-else>-</div>
                    </span>
                  </div>
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Version</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['registrationType'] || '-'}}</span>
                    </div>
                  </div>
                </div>

                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Manufacturer</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['Manufacturer'] || '-'}}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Submitted</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <span
                          v-if="data['rawSubmissionDate']!='N/A' && data['rawSubmissionDate']!='Invalid date' && data['rawSubmissionDate']"
                        >{{data['rawSubmissionDate'] | date}}</span>
                        <span v-else>-</span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Approved</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <span
                          v-if="data['Status'] === 'Pending' && data['notYetApprovedStatus']"
                        >Not yet approved</span>
                        <span
                          v-else-if="data['rawApprovalDate']!='N/A' && data['rawApprovalDate']!='Invalid date' && data['rawApprovalDate']"
                        >{{data['rawApprovalDate'] | date}}</span>
                        <span v-else>-</span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Expires</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <span
                          v-if="!data['notYetApprovedStatus'] && data['doesNotExpireStatus']"
                        >Does not expire</span>
                        <span v-else-if="data['notYetApprovedStatus']">-</span>
                        <span v-else>
                          <span
                            v-if="data['rawExpirationDate'] && data['rawApprovalDate']!='Invalid date' && data['rawExpirationDate']!='N/A'"
                          >{{data['rawExpirationDate'] | date}} ({{data['rawExpirationDate'] | fromNow}})</span>
                          <span v-else>-</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Alert date</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <span v-if="data['doesNotExpireStatus']">N/A</span>
                        <span v-else-if="!data['alertBeforeMonths']">-</span>
                        <span v-else>{{data['alertBeforeMonths']}} months before expiration</span>
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-md-12 padding-reset padding-top-edit"
                    v-if="this.data['registrationMinimumRenewalDate'] !== 0 &&
                    this.data['registrationMinimumRenewalDate'] !== null"
                  >
                    <div class="col-md-5">Earliest Renewal Date</div>
                    <div class="col-md-7">
                      <span
                        v-if="
                            data['rawExpirationDate'] !== 'N/A' &&
                            data['rawExpirationDate'] !== 'No expiration' &&
                            data['rawExpirationDate'] !== 'Invalid date'
                        "
                        class="text-bold"
                      >
                        <span>
                          <span
                            v-if="
                              minimumRenewalDate !== 'Invalid date' &&
                                minimumRenewalDate !== null &&
                                data['rawExpirationDate'] !== 'N/A' &&
                                data['rawExpirationDate'] !== null
                            "
                          >{{ minimumRenewalDate }}</span>
                          <span v-else>-</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-md-12 padding-reset padding-top-edit"
                    v-if="
                    this.data['registrationRenewalDeadline'] !== 0 &&
                    this.data['registrationRenewalDeadline'] !== null"
                  >
                    <div class="col-md-5">Renewal deadline</div>
                    <div class="col-md-7">
                      <span
                        v-if="
                        data['rawExpirationDate'] !== 'N/A' &&
                        data['rawExpirationDate'] !== 'No expiration' &&
                        data['rawExpirationDate'] !== 'Invalid date'"
                        class="text-bold"
                      >
                        <span>
                          <span
                            v-if="
                              renewalDeadline !== 'Invalid date' &&
                                renewalDeadline !== null &&
                                data['rawExpirationDate'] !== 'N/A' &&
                                data['rawExpirationDate'] !== null
                            "
                          >{{ renewalDeadline }}</span>
                          <span v-else>-</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Submission number</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <span v-if="!data['submissionNumber']">-</span>
                        <span v-else>{{data['submissionNumber']}}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr />
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">{{loggedInUser.company}} contact</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['medCompContact'] || '-'}}</span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Local representative</div>
                    <div class="col-md-7">
                      <span class="text-bold pointer">{{data['Local representative'] || '-'}}</span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit" v-if="roleId !== 6">
                    <div class="col-md-5">Local distributor</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div v-if="data['Local distributor']">
                          <div
                            v-for="distLoc of data['Local distributor'].split(', ')"
                            :key="distLoc"
                          >
                            <span @click="setSearch(distLoc)" class="pointer">{{distLoc}}</span>
                          </div>
                        </div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>

                  <div class="col-md-12 padding-reset padding-top-edit" v-if="roleId !== 6">
                    <div class="col-md-5">Issued by</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div v-if="data['Issued by']">{{data['Issued by']}}</div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Device UDI</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div v-if="data['Device UDI']" class="pointer">{{data['Device UDI']}}</div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Device part number</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div v-if="data['Part number']">
                          <div v-for="partNo of data['Part number'].split(',')" :key="partNo">
                            <span @click="setSearch(partNo)" class="pointer">{{partNo}}</span>
                          </div>
                        </div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>

                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Configuration</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div v-if="data['Configuration']" class="pointer">{{data['Configuration']}}</div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr />
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Device type</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div v-if="data['Device type']" class="pointer">{{data['Device type']}}</div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Device family</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div v-if="data['Device family']" class="pointer">{{data['Device family']}}</div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr />
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Device hardware version</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div
                          v-if="data['Device hardware version']"
                        >{{data['Device hardware version']}}</div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-12 padding-reset padding-top-edit">
                    <div class="col-md-5">Device software version</div>
                    <div class="col-md-7">
                      <span class="text-bold">
                        <div
                          v-if="data['Device software version']"
                        >{{data['Device software version']}}</div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Related records</div>
                    <div class="col-md-7 related-certificate">
                      <span class="text-bold">
                        <div v-if="relatedCertificates.length > 0">
                          <div
                            v-for="(relatedCertificate,index) of relatedCertificates"
                            :key="index"
                          >
                            <span>{{relatedCertificate.certificateNumber}}</span>
                            <span v-if="relatedCertificate.expirationDate">
                              (
                              <span v-if="dateStatus(relatedCertificate.expirationDate)<0">Expires</span>
                              <span v-else>Expired</span>
                              {{relatedCertificate.expirationDate | fromNow}})
                            </span>
                          </div>
                        </div>
                        <div v-else>-</div>
                      </span>
                    </div>
                  </div>
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Related Products</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['relatedProduct'] || '-'}}</span>
                    </div>
                  </div>
                </div>

                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Comments</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['Comments'] || '-'}}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <hr />
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Standards</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['standards'] || '-'}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Ordinance</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['ordinance'] || '-'}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Imported product</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['imported_product'] === true ? 'Yes' : 'No'}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Importer</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['importer'] || '-'}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Requester</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['requester'] || '-'}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Trade representative</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['trade_representative'] || '-'}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Status</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['inputStatus'] || '-'}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Test report</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['test_report'] || '-'}}</span>
                      <div v-if="data['test_report_attachments']">
                      <div v-for="(file,index) in data['test_report_attachments']" :key="index">
                        <span class="text-bold" v-if="!checkConfidentiality(file.highlyConfidential)"
                        >{{ file.attachmentLink.split("/")[file.attachmentLink.split("/").length - 1] }}</span>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Product certificate</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['product_certificate'] || '-'}}</span>
                      <div v-if="data['product_certificate_attachments']">
                      <div v-for="(file,index) in data['product_certificate_attachments']" :key="index">
                        <span class="text-bold" v-if="!checkConfidentiality(file.highlyConfidential)"
                        >{{ file.attachmentLink.split("/")[file.attachmentLink.split("/").length - 1] }}</span>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Barcode</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{data['barcode'] || '-'}}</span>
                      <div v-if="data['barcode_attachments']">
                      <div v-for="(file,index) in data['barcode_attachments']" :key="index">
                        <span class="text-bold" v-if="!checkConfidentiality(file.highlyConfidential)"
                        >{{ file.attachmentLink.split("/")[file.attachmentLink.split("/").length - 1] }}</span>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr />
                </div>
                <div class>
                  <div class="col-md-12 padding-reset">
                    <div class="col-md-5">Attachments</div>
                    <div class="col-md-7">
                      <span class="text-bold">{{attachmentText()}}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="clear: both;">
          <button
            type="button"
            class="btn btn-modal-footer cancel"
            style="float: left;background: #fff;"
            @click="closePopup"
          >
            <i class="fa fa-times-circle"></i> Cancel
          </button>
          <button
            type="button"
            class="btn btn-export"
            style="background: #fff; float: right;"
            @click="sendEmail"
            :disabled="disableSubmit"
          >
            <i class="fa fa-envelope"></i> Send email
          </button>
        </div>
      </div>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import * as moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import vSelect from '../UIComponents/Select.vue';
import { sendDetailsByEmail } from '../../apis/email';

export default {
  components: {
    Loader,
    vSelect,
  },
  props: {
    roleId: Number,
    data: Object,
    meta: Object,
    relatedCertificates: Array,
    loggedInUser: Object,
    permissions: Array,
  },
  data() {
    return {
      emergoEmail: '',
      emailSubject: '',
      selectedUsers: [],
      ramsUserList: [],
      registrationLink: '',
      errors: [],
      loaderStatus: false,
      placeValue: 'Enter one or more email addresses',
      emailNote: '',
    };
  },
  filters: {
    date(value) {
      if (value) {
        return moment.utc(value).format('DD MMM YYYY');
      }
      return '';
    },
    fromNow(value) {
      if (value) {
        return moment.utc(value).fromNow();
      }
      return '';
    },
  },
  methods: {
    checkConfidentiality(confidentiality) {
      const highlyConfidentialPermission = this.permissions.indexOf('HIGHLY_CONFIDENTIAL') > -1;
      return confidentiality && !highlyConfidentialPermission;
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    attachmentText() {
      if (this.data.attachmentLinks) {
        return this.data.attachmentLinks
          .map((attachment) => attachment.split('/').pop())
          .join(', ');
      }
      return '-';
    },
    statusColor(status) {
      if (status) {
        if (status.toLowerCase() === 'active') {
          return 'registration-status-title-active';
        }
        if (status.toLowerCase() === 'pending') {
          return 'registration-status-title-pending';
        }
        if (status.toLowerCase() === 'expiring soon') {
          return 'registration-status-title-expiring';
        }
        if (status.toLowerCase() === 'expired') {
          return 'registration-status-title-expired';
        }
        if (status.toLowerCase() === 'archived') {
          return 'registration-status-title-archived';
        }
      }
      return '';
    },
    dateStatus(value) {
      return moment().diff(moment(value), 'days');
    },
    countryFlag(code) {
      if (code) {
        return `flag-icon-${code.toLowerCase()}`;
      }
      return '';
    },
    async sendEmail() {
      this.loaderStatus = true;
      const shareEmailObj = {};
      shareEmailObj.certOrReg = 1;
      shareEmailObj.certOrRegId = this.meta.id;

      shareEmailObj.mailSubject = this.emailSubject;
      shareEmailObj.sendToOption = 1;

      if (this.meta.mode === '3') {
        shareEmailObj.mode = 'emergo';
        shareEmailObj.mailSendToList = [
          { emailId: this.emergoEmail },
        ];
      } else {
        shareEmailObj.mailSendToList = this.selectedUsers;
      }
      if (this.emailNote) shareEmailObj.mailNotes = this.emailNote;
      shareEmailObj.isSendLinkOnly = this.meta.isLink;
      const result = await sendDetailsByEmail(shareEmailObj);
      this.loaderStatus = false;
      if (result) {
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: `${this.meta.isLink ? 'Registration link email sent' : 'Registration details email sent'}`,
          group: 'custom-notification',
        });
        this.closePopup();
      } else {
        // this.$notify({
        //   clear: true,
        //   group: 'custom-notification',
        // });
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: `${this.meta.isLink ? 'Registration link email failed' : 'Registration details email failed'}`,
          group: 'custom-notification',
        });
      }
    },
    closePopup() {
      this.selectedUsers = [];
      this.emailSubject = '';
      this.emailNote = '';
      $('#registrationEmailLink').modal('hide');
    },
    updateText(empty) {
      if (empty) {
        this.placeValue = '';
      } else {
        this.placeValue = 'Enter one or more email addresses';
      }
    },
  },
  watch: {
    meta() {
      if (this.meta.isLink) {
        const currentURLParts = window.location.href.split('/');
        currentURLParts.splice(currentURLParts.length - 1, 1);
        this.registrationLink = `${currentURLParts.join('/')}/email/1/${
          this.meta.id
        }`;
      }

      if (this.meta.mode === '3') {
        this.emailSubject = 'Seeking support with registration renewal';
      } else if (this.meta.isLink) {
        this.emailSubject = 'Conformity Declaration Management Registration Link';
      } else {
        this.emailSubject = 'Conformity Declaration Management Registration Details';
      }
    },
  },
  computed: {
    disableSubmit() {
      if (
        (this.meta.mode === '3' && this.emergoEmail)
        || (this.meta.mode !== '3' && this.selectedUsers.length)
      ) {
        this.updateText(true);
        return false;
      }
      this.updateText(false);
      return true;
    },
    minimumRenewalDate() {
      const x = new Date(this.data.rawExpirationDate);
      let m;
      if (this.data.registrationMinimumRenewalDate === 100) {
        m = moment.utc(x.setMonth(x.getMonth())).format('DD MMM YYYY');
      } else {
        m = moment
          .utc(
            x.setMonth(x.getMonth() - this.data.registrationMinimumRenewalDate),
          )
          .format('DD MMM YYYY');
      }
      return m;
    },
    renewalDeadline() {
      const x = new Date(this.data.rawExpirationDate);
      let m;
      if (this.data.registrationRenewalDeadline === 100) {
        m = moment.utc(x.setMonth(x.getMonth())).format('DD MMM YYYY');
      } else {
        m = moment
          .utc(x.setMonth(x.getMonth() - this.data.registrationRenewalDeadline))
          .format('DD MMM YYYY');
      }

      return m;
    },
  },
  mounted() {
    $('#registrationEmailLink').on('shown.bs.modal', this.initialAPICalls);
  },
};
</script>
<style>
body {
  padding-right: 0px !important;
}
.mail-body {
  height: 45vh;
  overflow:auto;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
}
#registrationEmailLink .v-select .dropdown-toggle {
  background-image: none;
  padding: 0 15px 0 25px;
}
#registrationEmailLink .v-select input[type="search"] {
  padding-left: 0px;
  padding-right: 0px;
}
.email-popup .pointer {
  cursor: text;
}
.email-popup .pointer:hover {
  text-decoration: none;
}
/* .success-template {
  height: 90px;
  width: 493px;
  border-radius: 10px;
  background: #ffff;
  position: absolute;
  bottom: 0px;
  right: 0px;
} */
/* .success-template-icon {
  height: 39px;
  padding: 10px;
  width: 39px;
  position: absolute;
  left: 5.07%;
  right: 87.02%;
  top: 27.78%;
  bottom: 28.89%;
  background: #4C9E45;
  border-radius: 21px;
}
.success-template-close {
  position: absolute;
  left: 92.42%;
  right: 2.72%;
  top: 36.67%;
  bottom: 36.67%;
  cursor: pointer;
}
.success-template-title {
  position: absolute;
  left: 15.74%;
  right: 49.98%;
  top: 18.89%;
  bottom: 47.78%;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #4C9E45;
}
.success-template-text{
  position: absolute;
  left: 77px;
  top: 48px;
} */
@media (min-width: 768px) {
  #registrationEmailLink .v-select input[type="search"] {
    width: 300px !important;
  }
}
@media (min-width: 600px) and (max-width: 992px){
  #registrationEmailLink .v-select input[type="search"] {
    font-size: 11px;
  }
}
@media (min-width: 768px) and (max-width: 1279px){
  .mail-body {
    height: 30vh;
    overflow:auto;
  }
}
@media screen and (max-width: 1367px){
  .modal-lg.email-share-dialog {
    margin: 20px auto;
  }
}
</style>
